/* Flemar custom JS — loaded from layout/theme.liquid next to flemar-custom.css (re-add the loader after any Streamline update).
   Small, add-only fixes for Streamline behaviour. Keep each fix self-contained and dated. */
(function () {
  'use strict';

  /* 2026-09-23 — the mobile bottom bar keeps its cart block after the basket is emptied.
     Streamline adds `cart-has-items` to <body> on ajaxProduct:added and never removes it when
     the drawer's quantity control brings the cart back to zero (pre-existing on 6.5.2 and 7.2.0).
     cart:updated carries the cart payload on every quantity change: mirror its item_count. */
  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart || typeof cart.item_count !== 'number') return;
    document.body.classList.toggle('cart-has-items', cart.item_count > 0);
  });
})();

/* 2026-09-23 — mobile menu sheet: the page kept scrolling behind the open sheet, so the menu felt
   "scrollable way more than necessary" (pre-existing on live). The open state is `is-active` on the
   bottom-bar button (.site-nav__thumb-button); body.sticky-nav--is-open only means the bar exists
   and is present at load — never key on it. While the sheet is open, lock the page scroll the
   iOS-safe way (fix the body at its scroll position, restore on close). Mobile only. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 768px)');
  var locked = false, y = 0;
  function isOpen() {
    var btn = document.querySelector('.site-nav__thumb-button');
    return !!(btn && btn.classList.contains('is-active'));
  }
  function sync() {
    var open = mq.matches && isOpen();
    var st = document.body.style;
    if (open && !locked) {
      y = window.scrollY || window.pageYOffset || 0;
      st.position = 'fixed'; st.top = (-y) + 'px'; st.left = '0'; st.right = '0'; st.width = '100%';
      locked = true;
    } else if (!open && locked) {
      st.position = ''; st.top = ''; st.left = ''; st.right = ''; st.width = '';
      window.scrollTo(0, y);
      locked = false;
    }
  }
  function init() {
    var btn = document.querySelector('.site-nav__thumb-button');
    if (!btn || !('MutationObserver' in window)) return;
    new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['class'] });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 2026-09-23 — PERF-2, middle path: on phones the hero paints the still first (flemar-custom.css);
   the video is then loaded late and cross-faded over it, but only when the connection looks good.
   Skipped when: data saver is on, the connection reports 2g/3g, reduced motion is preferred, or
   the page is hidden. Unknown connection (Safari has no Network Information API) = assumed good.
   Start = window load + 2.5 s so the video never competes with fonts and product images. */
(function () {
  'use strict';
  if (!window.matchMedia('(max-width: 768px)').matches) return;
  var DELAY = 2500;
  var videos = [];

  // Streamline's VideoSection calls play() on the hero at load and, when that fails, turns the native
  // controls on (its "low power mode" fallback). With the source removed, play() fails by design, so
  // the theme adds controls — strip them whenever they appear (2026-09-23, Nassim's report).
  function keepControlsOff(v) {
    v.controls = false;
    v.removeAttribute('controls');
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        if (v.hasAttribute('controls')) { v.controls = false; v.removeAttribute('controls'); }
      }).observe(v, { attributes: true, attributeFilter: ['controls'] });
    }
  }

  function stop() {
    document.querySelectorAll('.video-parent-section video.video-div').forEach(function (v) {
      var src = v.getAttribute('src');
      if (!src) return;
      try { v.pause(); } catch (e) {}
      v.removeAttribute('autoplay');
      v.preload = 'none';
      v.removeAttribute('src');
      try { v.load(); } catch (e) {}
      keepControlsOff(v);
      videos.push({ el: v, src: src });
    });
  }

  function connectionLooksGood() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    if (!c) return true; // unknown: assume good
    if (c.saveData) return false;
    if (/(^|-)2g$|^3g$/.test(c.effectiveType || '')) return false;
    if (typeof c.downlink === 'number' && c.downlink > 0 && c.downlink < 1.5) return false;
    return true;
  }

  function start() {
    if (document.hidden || !connectionLooksGood()) return;
    videos.forEach(function (item) {
      var v = item.el;
      v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', '');
      v.setAttribute('muted', ''); v.setAttribute('autoplay', '');
      v.controls = false; v.removeAttribute('controls');
      v.preload = 'auto';
      v.classList.add('flemar-video-ready');
      v.addEventListener('playing', function () { v.classList.add('flemar-video-playing'); }, { once: true });
      v.src = item.src;
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* autoplay refused: the still stays */ });
    });
  }

  function schedule() {
    if (document.readyState === 'complete') setTimeout(start, DELAY);
    else window.addEventListener('load', function () { setTimeout(start, DELAY); }, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { stop(); schedule(); });
  else { stop(); schedule(); }
})();

/* 2026-09-25 - PERF-5: snippets/product-images.liquid marks every gallery slide but the featured
   one loading="lazy" so they stop competing with the LCP image. Hidden slides never intersect the
   viewport, so once the first image has arrived (or 2.5 s at worst) flip them back to eager: they
   download right behind the LCP image and are in place long before anyone swipes. */
(function () {
  if (!document.querySelector('[data-product-photos]')) return;
  var done = false;
  function wake() {
    if (done) return;
    done = true;
    document.querySelectorAll('[data-product-photos] img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  }
  function arm() {
    var first = document.querySelector('[data-product-photos] img:not([loading="lazy"])');
    if (!first) { wake(); return; }
    if (first.complete) { wake(); return; }
    first.addEventListener('load', wake, { once: true });
    first.addEventListener('error', wake, { once: true });
    setTimeout(wake, 2500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();

/* 2026-09-26 - item 03, "choose your size" (Nassim's call after option (b)): Shopify always resolves a
   product URL to the first variant, so every slipper opened on size 33. Instead of guessing a better
   default, the page now opens with no size chosen: the size grid is blank, the add-to-cart button
   reads "Choisissez votre taille" as a ghost button, and a tap on it (main button or sticky bar)
   scrolls to the grid, pulses it and shows a one-line hint. The first size picked hands control back
   to Streamline (price, URL, gallery, button text). Skipped when the URL names a variant (links from
   e-mails, ads, the cart). Strings come from sections/flemar-size-i18n.liquid (locales, flemar.size);
   the French below is the fallback. */
(function () {
  if (!/^\/(?:[a-z]{2}\/)?products\//.test(location.pathname)) return;
  if (/[?&]variant=/.test(location.search)) return;
  var I18N = { choose: 'Choisissez votre taille', hint: "Sélectionnez votre taille pour l'ajouter au panier", placeholder: 'Votre taille' };
  try {
    // the t filter HTML-escapes (' becomes &#39;): decode before the strings reach textContent
    var i18nEl = document.querySelector('[data-flemar-size-i18n]');
    var decoder = document.createElement('textarea');
    if (i18nEl) {
      var parsed = JSON.parse(i18nEl.textContent);
      for (var k in parsed) if (parsed[k]) { decoder.innerHTML = parsed[k]; I18N[k] = decoder.value; }
    }
  } catch (e) { /* fallback strings stay */ }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function run() {
    var scope = document.querySelector('.product-section');
    if (!scope) return;
    var form = scope.querySelector('form[action*="/cart/add"]');
    var btn = form && form.querySelector('[data-add-to-cart]');
    if (!form || !btn) return;
    var txt = btn.querySelector('[data-add-to-cart-text]') || btn;
    var master = form.querySelector('select[name="id"]');
    // Streamline renders the option controls outside the <form> (linked by the form attribute):
    // a fieldset of radios (button picker) or a <select> (dropdown picker), both data-index="option1".
    var wrap = scope.querySelector('.variant-input-wrap[data-index="option1"]');
    var radios = wrap ? Array.prototype.slice.call(wrap.querySelectorAll('input[type="radio"]')) : [];
    var select = wrap ? null : scope.querySelector('select[data-index="option1"][class*="variant__input-"]');
    if (!radios.length && !select) return;
    if (radios.length && !radios.some(function (r) { return r.checked; })) return; // nothing preselected: nothing to do

    var target = wrap || select;
    var pending = true;
    var originalText = txt.textContent;

    // 1. blank the choice
    if (radios.length) radios.forEach(function (r) { r.checked = false; });
    else {
      var ph = document.createElement('option');
      ph.value = ''; ph.textContent = I18N.placeholder; ph.disabled = true; ph.selected = true;
      select.insertBefore(ph, select.firstChild);
      select.value = '';
    }
    if (master) master.selectedIndex = -1;
    btn.classList.add('flemar-size-pending');
    txt.textContent = I18N.choose;
    btn.setAttribute('aria-describedby', 'FlemarSizeHint');
    document.documentElement.classList.add('flemar-size-pending-page');

    // 2. the hint, under the size control, silent until needed
    var hint = document.createElement('p');
    hint.id = 'FlemarSizeHint';
    hint.className = 'flemar-size-hint';
    hint.setAttribute('role', 'status');
    hint.setAttribute('aria-live', 'polite');
    hint.hidden = true;
    hint.textContent = I18N.hint;
    (wrap || select.closest('.variant-wrapper') || select.parentNode).insertAdjacentElement('afterend', hint);

    // 3. first choice: hand back to the theme (capture phase, so this runs before Streamline's
    //    own change handler restores the right button text: add to cart / sold out)
    function chosen() {
      if (!pending) return;
      pending = false;
      btn.classList.remove('flemar-size-pending');
      btn.removeAttribute('aria-describedby');
      document.documentElement.classList.remove('flemar-size-pending-page');
      txt.textContent = originalText;
      hint.hidden = true;
      target.classList.remove('flemar-size-nudge');
    }
    scope.addEventListener('change', function (evt) {
      if (!pending) return;
      var el = evt.target;
      if (radios.indexOf(el) !== -1 && el.checked) chosen();
      else if (el === select && select.value) chosen();
    }, true);

    // 4. add to cart without a size: no dead button, a nudge towards the grid
    function nudge(evt) {
      if (!pending) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      target.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
      hint.hidden = false;
      target.classList.remove('flemar-size-nudge');
      void target.offsetWidth; // restart the animation
      target.classList.add('flemar-size-nudge');
      var first = radios.length ? (radios.filter(function (r) { return !r.classList.contains('disabled'); })[0] || radios[0]) : select;
      if (first && first.focus) try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
    btn.addEventListener('click', nudge, true);
    form.addEventListener('submit', nudge, true);
  }

  function schedule() { setTimeout(run, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();

/* 2026-09-26 - quantity stepper (Nassim's feedback): Streamline's product template ships a bare
   <input type="number">. Wrap it with − and + buttons, keep the field editable, clamp to min/max and
   fire the input's change event so the theme sees the new value. Labels come from the size i18n
   block (flemar.qty.*); French is the fallback. */
(function () {
  if (!/^\/(?:[a-z]{2}\/)?products\//.test(location.pathname)) return;
  var I18N = { qty_decrease: 'Diminuer la quantité', qty_increase: 'Augmenter la quantité' };
  try {
    var el = document.querySelector('[data-flemar-size-i18n]');
    var dec = document.createElement('textarea');
    if (el) { var parsed = JSON.parse(el.textContent); for (var k in parsed) if (parsed[k] && k in I18N) { dec.innerHTML = parsed[k]; I18N[k] = dec.value; } }
  } catch (e) { /* fallback strings stay */ }

  var ICON_MINUS = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8h10"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 3v10M3 8h10"/></svg>';

  function build(input) {
    if (input.closest('.flemar-qty')) return;
    var min = parseInt(input.getAttribute('min'), 10); if (isNaN(min)) min = 1;
    var max = parseInt(input.getAttribute('max'), 10); if (isNaN(max)) max = Infinity;
    var box = document.createElement('div');
    box.className = 'flemar-qty';
    var minus = document.createElement('button');
    minus.type = 'button'; minus.className = 'flemar-qty__btn flemar-qty__btn--minus';
    minus.setAttribute('aria-label', I18N.qty_decrease); minus.innerHTML = ICON_MINUS;
    var plus = document.createElement('button');
    plus.type = 'button'; plus.className = 'flemar-qty__btn flemar-qty__btn--plus';
    plus.setAttribute('aria-label', I18N.qty_increase); plus.innerHTML = ICON_PLUS;
    input.parentNode.insertBefore(box, input);
    box.appendChild(minus); box.appendChild(input); box.appendChild(plus);
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('pattern', '[0-9]*');
    input.setAttribute('autocomplete', 'off');

    function current() { var v = parseInt(input.value, 10); return isNaN(v) ? min : v; }
    function reflect() {
      var v = current();
      minus.setAttribute('aria-disabled', v <= min ? 'true' : 'false');
      plus.setAttribute('aria-disabled', v >= max ? 'true' : 'false');
    }
    function set(v) {
      v = Math.max(min, Math.min(max, v));
      if (String(v) !== input.value) {
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      reflect();
    }
    minus.addEventListener('click', function () { set(current() - 1); });
    plus.addEventListener('click', function () { set(current() + 1); });
    input.addEventListener('change', function () { set(current()); });
    input.addEventListener('input', reflect);
    reflect();
  }

  function run() {
    document.querySelectorAll('.product-section .product__quantity input[type="number"]').forEach(build);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* 2026-09-27 - RB (review F13): assets/theme.js is pristine Streamline 7.2.0 again. The behaviour Flemar
   had edited into it is re-applied here, from the outside, so the next Streamline update leaves the file
   alone. Timing: both scripts are deferred, this one first, and theme.js registers its sections
   synchronously while it runs (its DOMready shortcut fires because the document is already
   "interactive"). So anything that must be in place before a section is constructed cannot wait for
   DOMContentLoaded: it is hooked through a setter on window.theme that fires the moment theme.js assigns
   the module. Dropped on purpose: the two stacked-gallery scroll tweaks (no template renders the stacked
   gallery, the seven product templates use the slider) and theme.Mobile (it served a language picker that
   is commented out in the header). */
(function () {
  'use strict';
  window.theme = window.theme || {};
  var theme = window.theme;

  // Run `wrap` on the value theme.js assigns to theme[name]; the wrapped value is what theme.js then uses.
  function intercept(name, wrap) {
    var stored = theme[name];
    Object.defineProperty(theme, name, {
      configurable: true,
      enumerable: true,
      get: function () { return stored; },
      set: function (v) { stored = wrap(v); }
    });
  }

  // 1. Product gallery: previous / next arrows on the main slider (theme.js used to set
  //    prevNextButtons: true in the slider arguments).
  function withArrows(Product) {
    if (Product && Product.prototype && typeof Product.prototype.initSliders === 'function' && !Product.prototype.flemarArrows) {
      var initSliders = Product.prototype.initSliders;
      Product.prototype.initSliders = function (args, reload) {
        if (args && typeof args === 'object') args.prevNextButtons = true;
        return initSliders.call(this, args, reload);
      };
      Product.prototype.flemarArrows = true;
    }
    return Product;
  }

  // 2. Testimonials stay a static row / stack (theme.css.liquid lays them out), not a Flickity slider:
  //    theme.js used to have the whole Testimonials module commented out. The section is registered with
  //    an inert constructor instead, and the vendor module stays untouched.
  function staticTestimonials() { return function FlemarStaticTestimonials() {}; }

  if (theme.Product) {
    // theme.js already ran (load order changed?): best effort, existing instances keep the vendor behaviour
    withArrows(theme.Product);
    theme.Testimonials = staticTestimonials();
  } else {
    intercept('Product', withArrows);
    intercept('Testimonials', staticTestimonials);
  }

  // 3. Predictive search: sold-out products last (theme.js used to add the parameter by hand). Only
  //    matters when someone types, so patching the element's prototype at DOMContentLoaded is early enough.
  function patchPredictiveSearch() {
    var PS = window.customElements && customElements.get('predictive-search');
    if (!PS || !PS.prototype || typeof PS.prototype.paramUrl !== 'function' || PS.prototype.flemarPatched) return;
    var paramUrl = PS.prototype.paramUrl;
    PS.prototype.paramUrl = function (obj) {
      if (obj && 'resources[limit_scope]' in obj && !('resources[options][unavailable_products]' in obj)) {
        obj = Object.assign({}, obj, { 'resources[options][unavailable_products]': 'last' });
      }
      return paramUrl.call(this, obj);
    };
    PS.prototype.flemarPatched = true;
  }

  // 4. The header language picker (sections/header.liquid, Flemar markup on the vendor's disclosure
  //    pattern). The vendor only wires the footer's picker; wire the header's the same way.
  function initHeaderPickers(root) {
    if (typeof theme.Disclosure !== 'function') return;
    root.querySelectorAll('[data-section-type="header-section"] [data-disclosure-locale], [data-section-type="header-section"] [data-disclosure-currency]').forEach(function (el) {
      if (el.flemarDisclosure) return;
      el.flemarDisclosure = new theme.Disclosure(el);
    });
  }

  function onReady() {
    patchPredictiveSearch();
    initHeaderPickers(document);
  }
  if (document.readyState === 'loading' || !theme.Disclosure) document.addEventListener('DOMContentLoaded', onReady);
  else onReady();
  // theme editor: the header section re-renders on every setting change
  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target && evt.target.querySelectorAll) initHeaderPickers(evt.target);
  });
})();
